import { render, staticRenderFns } from "./samples.vue?vue&type=template&id=24780036&"
import script from "./samples.ts?vue&type=script&lang=ts&"
export * from "./samples.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports